export const timeInMs = {
  ONE_SECOND: 1000,
  FIFTEEN_SECONDS: 15 * 1000,
  TWENTY_SECONDS: 20 * 1000,
  ONE_MINUTE: 60 * 1000,
} as const;
